import React, { Fragment } from "react";
import { Routes, Route } from "react-router-dom";

// Home Pages
import HomeOne from '../pages/HomeOne';
import HomeTwo from '../pages/HomeTwo';
import HomeThree from '../pages/HomeThree';

// About Page
import About from '../pages/About';

// Blog Pages
import Blog from '../pages/Blog';
import BlogGrid from '../pages/BlogGrid';
import BlogDetails from '../pages/BlogDetails';

// Pricing Plans Page
import PricePlan from '../pages/PricePlan';

// Service Pages
import Service from '../pages/Service';
import ServiceDetails from '../pages/service/DCServiceDetails/ServiceDetails';

// Team Pages
import Team from '../pages/Team';
import TeamDetails from '../pages/TeamDetails';

// Project Pages
import Project from '../pages/Project';
import ProjectDetails from '../pages/ProjectDetails';

// Contact Page
import Contact from '../pages/Contact';

// Not Fouond Page
import NotFound from '../pages/NotFound';
import DataCapture from "../pages/service/DataCapture";
import DataIntelligence from "../pages/service/DataIntelligence";
import DataQuality from "../pages/service/DataQuality";
import DataStorage from "../pages/service/DataStorage";
import DataServices from "../pages/service/DataServices";
import DataStreaming from "../pages/service/DataStreaming";
import ScrollToTopPage from "../utils/scrolltotoppage";
import Insights from "../pages/Insights";
import Process from "../pages/Process";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import DynamicQRCodeGenerator from '../components/QRCodePage/DynamicQRCodeGenerator.js';
import DatumartService from "../pages/service/DatumartService.jsx";
import {EnquiryForm} from "../pages/service/EnquiryForm.jsx";
import Onboarding from "../pages/service/Onboarding.js";

const AppRouters = () => (
  <Fragment>
    <ScrollToTopPage>
      <Routes>
        <Route path="/" exact element={<DatumartService />} />
        <Route path="/register" element={<Onboarding/>}/>
        <Route path="/enquiry" element={<EnquiryForm formType="enquiry"/>} />
        <Route path="/onboarding" element={<EnquiryForm formType="register"/>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ScrollToTopPage>
  </Fragment>
);

export default AppRouters;